// extracted by mini-css-extract-plugin
module.exports = {"fieldGroupsTitle":"ScannedDocumentsLayout_fieldGroupsTitle__GKFdP"};